import type { ChartType, Plugin } from 'chart.js'

import { TDrawBandsPluginOptions } from 'components_new/molecules/charts/chartjs-plugins'

/**
 * Shaded spans behind the datasets, from one point to another.
 */
export const drawBands: Plugin<ChartType, TDrawBandsPluginOptions> = {
  id: 'drawBands',

  beforeDatasetsDraw(chart, _args, opt) {
    const { chartArea, ctx, scales } = chart

    opt.bands?.forEach((band) => {
      const from = scales.x.getPixelForValue(band.fromIndex)
      const to = scales.x.getPixelForValue(band.toIndex)

      ctx.save()
      ctx.fillStyle = band.color
      ctx.fillRect(
        from,
        chartArea.top,
        Math.max(to - from, 1),
        chartArea.bottom - chartArea.top
      )
      ctx.restore()
    })
  }
}
